import _ from 'lodash';

export const returnPaginationRange = (totalPageNumber: number, pageNumber: number, pageLimit: number, siblings: any) => {
    let totalPageNoInArray = 7 + siblings;
    if (totalPageNoInArray >= totalPageNumber) {
        return _.range(1, totalPageNumber + 1);
    }

    let leftSiblingsIndex = Math.max(pageNumber - siblings, 1);
    let rightSiblingsIndex = Math.min(pageNumber + siblings, totalPageNumber);

    let showLeftDots = leftSiblingsIndex > 2;
    let showRightDots = rightSiblingsIndex < totalPageNumber - 2;

    if (!showLeftDots && showRightDots) {
        let leftItemsCount = 3 + 2 * siblings;
        let leftRange = _.range(1, leftItemsCount + 1);
        return [...leftRange, "...", totalPageNumber];
    } else if (showLeftDots && !showRightDots) {
        let rightItemsCount = 3 + 2 * siblings;
        let rightRange = _.range(totalPageNumber - rightItemsCount + 1, totalPageNumber);
        return[1, "...", ...rightRange];
    } else {
        let middleRange= _.range(leftSiblingsIndex, rightSiblingsIndex + 1);
        return[1, "...", ...middleRange, "...", totalPageNumber];
    }
}